import { type CSSProperties, useCallback, useState } from 'react';

import { RollsPlayer } from '@/entities/rolls';
import { useJoinGame } from '@/shared/lib/hooks/useJoinGame';
import { useTelegramBackButton } from '@/shared/lib/telegram/useTelegramBackButton';

import { BetControls, PlayersList, PvpWheel, RollsStatusBar } from './ui';

export function RollsPage() {
  useTelegramBackButton();
  useJoinGame('roulette');
  const [spinPlayer, setSpinPlayer] = useState<RollsPlayer | null>(null);
  const handleCurrentPlayer = useCallback((player: RollsPlayer | null) => {
    setSpinPlayer(player);
  }, []);

  return (
    <div className="game-page" style={{ paddingBottom: '8rem' }}>
      <RollsStatusBar spinPlayer={spinPlayer} />

      <div
        className="game-page__canvas-wrap game-page__fade-in-scale"
        style={{ '--fade-in-delay': '0.1s' } as CSSProperties}>
        <PvpWheel onCurrentPlayer={handleCurrentPlayer} />
      </div>

      <div className="game-page__fade-in" style={{ '--fade-in-delay': '0.2s' } as CSSProperties}>
        <BetControls />
      </div>

      <div className="game-page__fade-in" style={{ '--fade-in-delay': '0.3s' } as CSSProperties}>
        <PlayersList />
      </div>
    </div>
  );
}
